import axios from 'axios';
import { request } from '@/api/request';
import { api_config } from '@/constants/api';

const MATERIAL_API_URL = 'https://nmaterial-api.afirstsoft.cn';
const PRICE_INFO_ID = '691689824bf3c76415caa9f4';
const MATERIAL_AUTH_KEY =
  'IlTkxhghFUPgkZh4nN79vHnvKCDnlAu5:OBdnziGDwYHQb07qH5FSMBUhX5hITS02JDOqkXCwUhYxiXXEniqJKgKrKYxLJpZA';

const materialClient = axios.create({
  baseURL: MATERIAL_API_URL,
  timeout: 60000,
});

materialClient.interceptors.request.use((config) => {
  config.headers.Authorization = `Basic ${window.btoa(MATERIAL_AUTH_KEY)}`;
  return config;
});

export const normalizePriceLocale = (locale) => {
  if (locale === 'tk') {
    return 'tr';
  }

  if (locale === 'inn') {
    return 'in';
  }

  return locale || 'en';
};

export const getPriceInfo = async (locale) => {
  const response = await materialClient.get(
    `/api/v1/product-material/id/${PRICE_INFO_ID}`,
    {
      params: {
        channel: 'HP OL SEO',
        source: 'HP Online',
      },
    }
  );
  const material = response.data && response.data.data;
  const configValue =
    material &&
    material.public_properties &&
    material.public_properties.material_config &&
    material.public_properties.material_config.value &&
    material.public_properties.material_config.value[0];

  if (typeof configValue !== 'string') {
    return {
      activePrice: null,
      priceList: [],
    };
  }

  const priceInfo = JSON.parse(configValue);
  const normalizedLocale = normalizePriceLocale(locale);
  const countryPriceInfo =
    priceInfo.find((item) => item && item.country === normalizedLocale) ||
    priceInfo.find((item) => item && item.country === 'en');
  const priceList =
    countryPriceInfo &&
    countryPriceInfo.ordinaryPackage &&
    Array.isArray(countryPriceInfo.ordinaryPackage.priceList)
      ? countryPriceInfo.ordinaryPackage.priceList
      : [];

  return {
    activePrice: priceList.find((item) => item && item.mostSelected) || null,
    priceList,
  };
};

export const getPurchaseLink = async ({ plan, site }) => {
  const response = await request(`${api_config.API_V2_URL}check-out-unify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      plan,
      site: normalizePriceLocale(site),
    }),
  });

  return response && response.data && !response.cart_url
    ? response.data
    : response;
};
